import axios from "axios"

/* Constants */
import * as env from "../constants/env"

/* Create Token — the key of the link is the static token of the stand */
export const create = (key, data) => {
    const uri = `${env.livekitService}/stand/create`
    const headers = { headers: { Authorization: `Bearer ${key}`, "Content-Type": "application/json" } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}
